import Vue from 'vue'
import {states} from './common-type.js'
Vue.prototype._switchType = function(sysm,str,k){
    let c = k;
    if(states[sysm][str]){
        states[sysm][str].map(v=>{
            if(v.code == k){
                c=v.value
            }
        })
    }
    return c
}


// WEBPACK FOOTER //
// ./src/server/switch-type.js